import { useFormContext, useFormState, useWatch } from 'react-hook-form';

import { useCheckout } from '@jane/shared-ecomm/providers';

import { useCheckoutDocs } from './useCheckoutDocs';
import { useValidatePickupAddress } from './useValidatePickupAddress';

export const useCheckoutInfoIsValid = () => {
  const {
    store: { birth_date_required, customer_pickup_address_required },
    appInfo: { appMode },
    selectedPickupAddress,
  } = useCheckout();
  const { requiredDocs } = useCheckoutDocs();

  const { control } = useFormContext();
  const values = useWatch({ control, name: 'customerInformation' });
  const { errors } = useFormState({ control });

  const {
    birthDate,
    email,
    firstName,
    governmentIdentificationUrl,
    lastName,
    mmjExpirationDate,
    mmjIdBackUrl,
    mmjIdFrontUrl,
    mmjIdNumber,
    phone,
    street2,
  } = values;

  const { governmentId, medicalExpirationDate, medicalPhoto, medicalNumber } =
    requiredDocs;
  const isHeadlessMode = appMode === 'headless';

  const { addressIsValid } = useValidatePickupAddress({
    address: selectedPickupAddress || '',
    street2: street2,
    isRequired: !!customer_pickup_address_required && isHeadlessMode,
    skip:
      !customer_pickup_address_required ||
      !isHeadlessMode ||
      !selectedPickupAddress,
  });

  const formValid =
    (!!addressIsValid ||
      !customer_pickup_address_required ||
      !isHeadlessMode) &&
    (!!birthDate || !birth_date_required) &&
    !!firstName &&
    !!lastName &&
    !!phone &&
    !!email &&
    !(
      errors?.['customerInformation'] &&
      Object.values(errors['customerInformation']).some(
        (error) => error?.message !== undefined
      )
    );

  const docsValid =
    (!governmentId || !!governmentIdentificationUrl) &&
    (!medicalExpirationDate || !!mmjExpirationDate) &&
    (!medicalNumber || !!mmjIdNumber) &&
    (!medicalPhoto || (!!mmjIdBackUrl && !!mmjIdFrontUrl));

  return {
    docsValid,
    formValid,
  };
};
